import { useMemo } from 'react'
import { Column } from './types'


export function useColumnTitles(currency: string = '₽') {
  const columns = useMemo(() => {
    return {
      [Column.Date]: 'Дата',
      [Column.Value]: `Сумма, ${currency}`,
      [Column.OperationType]: 'Тип',
      [Column.Comment]: 'Комментарий',
    }
  }, [currency])

  return columns
}
